import React from 'react';

export const AddBankAccountPromptText = ({ children }: React.PropsWithChildren) => (
    <div className="text-grey-2 mb-5 text-sm">
        RaiseRight uses <a href="#">Plaid</a> to link your bank account. By selecting this option, I
        acknowledge I have read and agree to the <a href="#">terms and conditions</a> and{' '}
        <a href="#">privacy policy</a>.{children}
    </div>
);
